var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransactionBgColor2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 64,
    viewBox: "0 0 45 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.23045 -10.4261C-0.668354 -11.9882 1.86431 -11.9882 3.42641 -10.4261L43.0244 29.1719C44.5865 30.734 44.5865 33.2667 43.0244 34.8288L3.42641 74.4267C1.86431 75.9888 -0.668354 75.9888 -2.23045 74.4267L-41.8284 34.8288C-43.3905 33.2667 -43.3905 30.734 -41.8284 29.1719L-2.23045 -10.4261Z",
    fill: "#DCE5F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionBgColor2);
export default __webpack_public_path__ + "static/media/TransactionBgColor2.0b6c9a1688dbd081a99fef3c884bc3c7.svg";
export { ForwardRef as ReactComponent };